/* Count-up (§10.9). [data-count-to] numbers count from 0 when half visible. The final value is
   server-rendered (no-JS and reduced motion just show it) and the animated copy is aria-hidden,
   with a visually hidden final value beside it. Keeps the merchant's decimals and separators. */
(() => {
  if (window.Theme.countUpReady) return;
  window.Theme.countUpReady = true;

  function parse(text) {
    const raw = text.trim();
    const match = raw.match(/^([^\d-]*)(-?[\d.,\s]+)(.*)$/);
    if (!match) return null;
    const digits = match[2].replace(/\s/g, '');
    // "1,240" / "1.240" (thousands) vs "4.9" / "4,9" (decimal): a 3-digit tail means thousands.
    const lastSep = Math.max(digits.lastIndexOf(','), digits.lastIndexOf('.'));
    const tail = lastSep === -1 ? '' : digits.slice(lastSep + 1);
    const decimals = lastSep !== -1 && tail.length !== 3 ? tail.length : 0;
    const decimalSep = decimals ? digits[lastSep] : '';
    const thousandSep = (digits.match(decimals ? (decimalSep === '.' ? /,/ : /\./) : /[.,]/) || [''])[0];
    const value = Number(digits.split(thousandSep || '\u0000').join('').replace(decimalSep || '\u0000', '.'));
    if (!Number.isFinite(value)) return null;
    return { prefix: match[1], suffix: match[3], value, decimals, decimalSep, thousandSep };
  }

  function format(n, p) {
    const [int, dec] = n.toFixed(p.decimals).split('.');
    const grouped = p.thousandSep ? int.replace(/\B(?=(\d{3})+(?!\d))/g, p.thousandSep) : int;
    return p.prefix + grouped + (dec ? p.decimalSep + dec : '') + p.suffix;
  }

  function run(el) {
    const parsed = parse(el.dataset.countTo);
    if (!parsed) return;
    const start = performance.now();
    const duration = 1400;
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      el.textContent = format(parsed.value * eased, parsed);
      if (t < 1) requestAnimationFrame(tick);
    };
    el.textContent = format(0, parsed);
    requestAnimationFrame(tick);
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (window.Theme.motionAllowed()) run(entry.target);
      });
    },
    { threshold: 0.5 }
  );

  const watch = (root) => root.querySelectorAll('[data-count-to]').forEach((el) => observer.observe(el));
  watch(document);
  document.addEventListener('shopify:section:load', (event) => watch(event.target));
})();
